(() => {
  'use strict';
  if (window.llOpenAIAds) return;
  const configElement = document.getElementById('ll-openai-ads-config');
  if (!configElement) return;
  let config;
  try { config = JSON.parse(configElement.textContent); } catch { return; }
  if (config.pixelId !== 'JdD4ostKrqwUgTZ6tTt5dm') return;
  let initialized = false;
  let viewed = false;
  let active = false;
  const leads = new Set();
  const allowed = () => {
    try {
      const privacy = window.Shopify?.customerPrivacy;
      return privacy?.analyticsProcessingAllowed() === true &&
        privacy?.marketingAllowed() === true && privacy?.saleOfDataAllowed() === true;
    } catch { return false; }
  };
  function initialize() {
    if (initialized) return;
    if (!window.oaiq) {
      const queue = function () { queue.q.push(arguments); };
      queue.q = [];
      window.oaiq = queue;
      const sdk = document.createElement('script');
      sdk.async = true;
      sdk.src = 'https://bzrcdn.openai.com/sdk/oaiq.min.js';
      document.head.appendChild(sdk);
    }
    // Set the SDK consent state before its first init, per OpenAI's contract.
    window.oaiq('consent', true);
    window.oaiq('init', { pixelId: config.pixelId });
    initialized = true;
    active = true;
  }
  function measure(name, data, eventId) {
    try {
      if (!allowed()) { syncConsent(); return false; }
      initialize();
      window.oaiq('measure', name, data, { event_id: eventId, opt_out: true });
      return true;
    } catch { return false; }
  }
  function syncConsent() {
    try {
      const consent = allowed();
      if (!consent) {
        if (initialized && active) window.oaiq('consent', false);
        active = false;
        return;
      }
      initialize();
      if (!active) { window.oaiq('consent', true); active = true; }
      if (!viewed) {
        viewed = measure('page_viewed', { type: 'contents', contents: [
          { id: config.pagePath, name: config.pageType, content_type: 'page' }
        ] }, 'page-' + crypto.randomUUID());
        if (config.product) measure('contents_viewed', {
          type: 'contents', contents: [config.product]
        }, 'product-' + crypto.randomUUID());
      }
    } catch { /* Reporting must never interrupt the store. */ }
  }
  function trackGoogleAdsLead(reference) {
    try {
      const sentIds = (window.__llGoogleAdsConversionIds = window.__llGoogleAdsConversionIds || new Set());
      if (sentIds.has(reference)) return false;
      const privacy = window.Shopify?.customerPrivacy;
      if (privacy && typeof privacy.marketingAllowed === 'function' && privacy.marketingAllowed() === false) return false;
      sentIds.add(reference);
      window.dataLayer = window.dataLayer || [];
      const gtagFn = typeof window.gtag === 'function'
        ? window.gtag
        : function () { window.dataLayer.push(arguments); };
      gtagFn('event', 'conversion', {
        send_to: 'AW-982050105/cGRNCIvbwLIYELnKo9QD',
        transaction_id: reference
      });
      return true;
    } catch { return false; }
  }
  function trackLead(reference, options) {
    try {
      // Only accept the site's random submission references, never contact data.
      if (typeof reference !== 'string' || !/^(LL|DC|OP|LK|PR|CH)-[A-Za-z0-9-]{8,64}$/.test(reference)) return false;
      const id = 'lead-' + reference;
      if (leads.has(id)) return false;
      // Remember denied events as well: do not replay leads after later consent.
      leads.add(id);
      if (!options || !options.skipGoogleAds) {
        trackGoogleAdsLead(reference);
      }
      return measure('lead_created', { type: 'customer_action' }, id);
    } catch { return false; }
  }
  window.llOpenAIAds = Object.freeze({ trackLead });
  // These four existing campaign embeds have separately verified form IDs.
  const campaignForms = {
    '/pages/sofa-design-services': '86f7a996-9a39-4fb5-bb51-ae2630516ace',
    '/pages/commercial': '3cc7e60d-3bae-431a-b16e-2bb6412a8a35',
    '/pages/recliner-enquiries': '39261d9b-fbc4-498b-8e6a-cea500465fc0',
    '/pages/bespoke-sofas-lounges': 'd8ea2a6a-1597-4157-a57b-d7c4134df36f'
  };
  let campaignTracked = false;
  window.addEventListener('message', event => {
    try {
      const expected = campaignForms[config.pagePath];
      if (!expected || campaignTracked || event.data?.type !== 'hsFormCallback' ||
          event.data?.eventName !== 'onFormSubmitted' || event.data?.id !== expected) return;
      if (event.origin !== window.location.origin &&
          !/^https:\/\/(?:[a-z0-9-]+\.)*hsforms\.(?:com|net)$/.test(event.origin)) return;
      campaignTracked = true;
      // Ignore submissionValues completely; send only a random event reference.
      // Skip Google Ads here because these 4 embedded pages already fire AW-982050105/cGRNCIvbwLIYELnKo9QD inline.
      trackLead('LL-' + crypto.randomUUID(), { skipGoogleAds: true });
    } catch { }
  });
  // Larkham already emits this event only after HubSpot HTTP acceptance.
  document.addEventListener('larkham:quote-accepted', event => {
    try { trackLead(event.detail?.reference); } catch { }
  });
  document.addEventListener('visitorConsentCollected', syncConsent);
  const start = () => {
    try {
      if (!window.Shopify?.customerPrivacy && window.Shopify?.loadFeatures) {
        window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }],
          error => { if (!error) syncConsent(); });
      } else syncConsent();
    } catch { }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
